module.exports = __webpack_public_path__ + "img/рз_31.94c28e54.png";